import { StateCreator } from "@/store/utils"
import { Process, Shift } from "@/types/user"

export interface UserState {
  employee: {
    code: string
    name: string
    email: string
  }
  plant: {
    name: string
    id: string
    city: string
  }
  shifts: Shift[]
  processes: Process[]
  token: string
}

export interface UserSlice {
  user: UserState
  setUserState(data: Partial<UserSlice["user"]>): void
  logout(): void
}

export const initialState: () => UserState = () => ({
  employee: {
    code: "",
    name: "",
    email: "",
  },
  plant: {
    name: "",
    id: "",
    city: "",
  },
  shifts: [],
  processes: [],
  token: "",
})

const createUserSlice: StateCreator<UserSlice> = (set, __get, store) => ({
  user: initialState(),
  setUserState(data) {
    set((state) => ({
      ...state,
      user: {
        ...state.user,
        ...data,
      },
    }))
  },
  logout() {
    return set((state) => ({
      ...state,
      user: {
        ...store.getInitialState().user,
      },
    }))
  },
})

export default createUserSlice
